import ChaptersTableContainer from './ChaptersTableContainer';

export default ChaptersTableContainer;
